import React from 'react'
import { getImgProps, LibraryGuideCard as LibraryGuideCardComponent } from '@superhi/design'

import { API } from '../../api'
import { buildPath } from '../../routing/utils'

type ComponentProps = Omit<React.ComponentProps<typeof LibraryGuideCardComponent>, 'link' | 'image'>

type Props = ComponentProps &
  API.LibraryGuideCardComponent & {
    imageLazy?: boolean
  }

const LibraryGuideCard: React.FC<Props> = ({ slug, image, imageLazy = false, ...props }) => {
  const imageProps = React.useMemo(
    () => ({
      ...getImgProps(
        image.url,
        {
          small: 100,
          medium: 50,
          large: 33,
          xlarge: 33,
        },
        {
          fm: 'png8',
        },
      ),
      lazy: imageLazy,
    }),
    [image.url, imageLazy],
  )

  const href = React.useMemo(
    () => buildPath('guides-view', { params: { guideSlug: slug } }),
    [slug],
  )

  return (
    <LibraryGuideCardComponent
      {...props}
      link={{ href }}
      image={{ ...imageProps, blurHash: image.blurhash }}
    />
  )
}

export { default as FRAGMENT } from './fragments'
export default LibraryGuideCard
